<div class="userpicture userpicture--{{this.size}}" [ngClass]="{'userpicture--collapsed': this.collapsed}">
    @if (this.status) {
<div class="userpicture__status">
        <app-status-badge [status]="this.status" [size]="this.size" />
    </div>
}
    @if (this.picture !== '' && this.picture) {
<img [src]="constants.ATSAPP_BASE_URL + '/speaker-files' + picture" alt="" class="userpicture__picture">
}
    @if (this.picture === '' || !this.picture) {
<div class="userpicture__nopicture">
        <span>
            {{ this.firstName | slice: 0 : 1}}{{ this.lastName | slice: 0 : 1}}
        </span>
    </div>
}
</div>
